export const HOME_PAGE = 'homepage';
export const MEMBERSHIP_PAGE = 'membership';
export const MEMBERSHIP_DETAIL_PAGE = 'membership_detail';
export const MY_MEMBERSHIP_PAGE = 'my_membership';
export const DUTYFREE_LISTING_PAGE = 'dutyfree_listing';
export const DUTYFREE_DETAIL_PAGE = 'dutyfree_detail';
export const PRODUCT_DETAIL_PAGE = 'product_detail';
export const RETAIL_CART_PAGE = 'retail_cart';
export const AUTOCHECKOUT_FORM = 'autocheckout_form';
export const SEARCH_FLIGHT_PAGE = 'search_flight';
export const FLIGHT_ARRIVAL_PAGE = 'flight_arrival';
export const FLIGHT_DEPARTURE_PAGE = 'flight_departure';
export const FLIGHT_DETAIL_PAGE = 'flight_detail';
export const MY_FLIGHTS_PAGE = 'my_flights';
export const BRB_PAGE = 'brb_service';
export const AIRPORT_HOME_PAGE = 'airport_home';
export const MEET_N_GREET_PAGE = 'meet_n_greet';
export const LOUNGE_LISTING_PAGE = 'lounge_listing';
export const LOUNGE_DETAIL_PAGE = 'lounge_detail';
export const ACTIVITIES_PAGE = 'activities';
export const CASHBACK_PAGE = 'cashback';
export const HISTORY_PAGE = 'history';
export const ORDERS_PAGE = 'orders';
